/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-71
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_234 from /* 234 */"./234"
var um = [
  {
    type: "WidgetTitle",
    hasDisableOrVisible: true
  }, {
    type: "VisibleSwitch"
  }, [
    {
      type: "Color",
      label: "textColor"
    }, {
      type: "BackgroundColor"
    }
  ], {
    type: "Size",
    sizeRange: [[Module_234.l, Module_234.j], [Module_234.k, Module_234.i]]
  }, {
    type: "Coordinate"
  }
]
export { um }
